import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/shared/components/organisms/alert/alert.service';
import { AlertLogLevel } from '@app/shared/models/alert-log.model';
import { Color } from '@app/shared/models/color.model';
import { SettingsService } from './settings.service';
import { SettingKeyEnum } from './settings.model';
import { MESSAGES } from '@app/shared/utils/messages';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
  standalone: false,
})
export class SettingsComponent implements OnInit {
  protected readonly Color = Color;

  isLoading: boolean = false;

  quota: number = 0;

  threshold: number = 0;

  originalQuota: number = 0;

  originalThreshold: number = 0;

  protected readonly Object = Object;

  protected readonly alertLogLevel = AlertLogLevel;

  constructor(
    private settingsService: SettingsService,
    private alertService: AlertService,
  ) {}

  ngOnInit() {
    this.settingsService.getSettings().subscribe({
      next: (response) => {
        this.quota = response.quota ?? 0;
        this.threshold = response.threshold ?? 0;

        this.originalQuota = this.quota;
        this.originalThreshold = this.threshold;
      },
      error: () => {
        this.alertService.error(MESSAGES.DEFAULT_ERROR);
      },
    });
  }

  quotaChange(value: number) {
    this.quota = value;
  }

  tresholdStateChange(value: number) {
    this.threshold = value;
  }

  get hasChanges(): boolean {
    return this.quota !== this.originalQuota || this.threshold !== this.originalThreshold;
  }

  save() {
    if (!this.hasChanges) return;

    this.isLoading = true;

    const params = {
      [SettingKeyEnum.Quota]: { old: this.originalQuota, new: this.quota },
      [SettingKeyEnum.Threshold]: { old: this.originalThreshold, new: this.threshold },
    };

    this.settingsService.postSettings(params).subscribe({
      next: () => {
        this.isLoading = false;
        this.alertService.success('Paramètres enregistrés avec succès');

        this.originalQuota = this.quota;
        this.originalThreshold = this.threshold;
      },
      error: () => {
        this.isLoading = false;
        this.alertService.error(MESSAGES.DEFAULT_ERROR);
      },
    });
  }
}
